// removed by extract-text-webpack-plugin
module.exports = {"form-control":"LabelInput__form-control__JG4fM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LabelInput/LabelInput.scss
// module id = 404
// module chunks = 0